import { render, staticRenderFns } from "./TopBarContainer.vue?vue&type=template&id=a1edd570&scoped=true"
import script from "./TopBarContainer.vue?vue&type=script&lang=js"
export * from "./TopBarContainer.vue?vue&type=script&lang=js"
import style0 from "./TopBarContainer.vue?vue&type=style&index=0&id=a1edd570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1edd570",
  null
  
)

export default component.exports